import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UniversityDepartmentComponent } from './university-department/university-department.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [],
    imports: [CommonModule, IonicModule, RouterModule, FormsModule, ReactiveFormsModule, MatTooltipModule, FontAwesomeModule,
UniversityDepartmentComponent],
    exports: [UniversityDepartmentComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UniversityDepartmentComponentModule {}
